import { Component, Inject, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { ListService } from '@app/common/services/list.service';
import { ListModel } from '@app/common/models/list.model';
import { Restangular } from 'ngx-restangular';
import { RoadNamePipe } from '@app/dimap/pipes/road-name.pipe';
import { getOrder } from '../../pure/listLoadOrder';
import { RoadClassNamePipe } from '@app/dimap/pipes/road-class-name.pipe';
import { DecimalPipe } from '@angular/common';
import { HelpService } from '@app/common/services/help.service';
import * as _ from 'lodash';

@Component({
  selector: 'diagnostics-overview',
  templateUrl: './diagnostics-overview.component.html',
  styleUrls: ['./diagnostics-overview.component.scss']
})
export class DiagnosticsOverviewComponent implements OnInit {
  helpIds = HelpService.HELP_IDS;
  list: ListModel<any>;
  districtStatusVisible = true;
  districtStatusesGrouped: any[]
  summaryList: ListModel<any>;
  summaryChart: any[];
  summaryChartLabel: any = {};
  filterRoadMaster =  {sortOrder: getOrder('road-masters/list')};
  filterDistrict = {};
  filterRoadClass = {};
  filterRoad = {};
  colors = ['ffffff', '1a9641', 'a6d96a', 'ffffbf', 'fdae61', 'd7191c'];
  globalFilter = {
     diagnosticsDivisionExists : {values: [true]},
     roadMasterId : {values: []},
     districtId : {values: []},
     roadClassId : {values: []},
     roadId : {values: []},
 }

  constructor(
    private restangular: Restangular,
    private listService: ListService,
    private stateService: StateService,
    private roadNamePipe: RoadNamePipe,
    public roadClassNamePipe: RoadClassNamePipe,
    private numberPipe: DecimalPipe,
  ) {
  }

  async ngOnInit() {
    this.summaryList = this.listService.createList('diagnostics/summary',
            {
              filters: _.assign({}, this.globalFilter)
            },
            undefined,
            {}
          );

    this.list = this.listService.createList('diagnostics/repairs',
      {
        filters: _.assign({}, this.globalFilter)
      },
      undefined,
      {}
    );

    this.loadDistrictStatus();
    await this.fetchResults();
  }

  onFilterChanged(): Promise<any> {
    return this.fetchResults();
  }

  loadDistrictStatus() {
    return this.restangular.all('district-statuses').customPOST({}).toPromise().then((districtStatuses) => {
        const districtStatusesGrouped = [];
        districtStatuses.forEach(ds => {
          let foundDs = districtStatusesGrouped.find(dsLocal => dsLocal.districtName == ds.districtName);
          if (!foundDs) {
            foundDs = {districtName : ds.districtName};
            districtStatusesGrouped.push(foundDs);
          }
          if (ds.roadClass) {
            foundDs['diagnosticsDate' + ds.roadClass] = ds.diagnosticsDate;
            foundDs['diagnosticsLength' + ds.roadClass] = ds.diagnosticsLength;
            foundDs['repairsLength' + ds.roadClass] = ds.repairsLength;
          }
        });
        this.districtStatusesGrouped = districtStatusesGrouped;
      });
  }

  fetchResults() {
      return Promise.all([

        this.listService.fetchResult(this.summaryList).then(data => {
          this.summaryChartLabel.totalCount = 0;
          this.summaryChartLabel.totalPrice = 0;
          this.summaryChart = data.list.map((v, i) => {
            this.summaryChartLabel.totalPrice += v.price;
            this.summaryChartLabel.totalCount += v.sectionCount;
            return {
              value: v.sectionCount, color: '#' + this.colors[i],
              tooltip: this.numberPipe.transform(v.sectionCount) + ' ' + (v.sectionCount==1 ? 'úsek' : (v.sectionCount > 1 && v.sectionCount < 5) ? 'úseky' : 'úseků') + '<br/>'
                + this.numberPipe.transform(v.price) + ' Kč'
            };
          });
          this.summaryChartLabel.totalPriceFormated = this.numberPipe.transform(this.summaryChartLabel.totalPrice);
        }),
        this.listService.fetchResult(this.list).then(data => {

        }),
      ]);
    }

    onToggleDistrictStatus() {
      this.districtStatusVisible = !this.districtStatusVisible;
    }
}
